<template>
<div id="apptable" v-cloak>

    <b-card :header="(this.$route.params.id != null ? 'Domande questionario #' + this.$route.params.id : 'Nuova domanda questionario')" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
        <div class="text-left">

            <div class="my-1 row">
                <div class="col-md-3">
                    <b-form-input v-model="filter" placeholder="Cerca..." />
                </div>                
                <div class="col-md-9 text-right">                    
                    <b-button size="md" variant="outline-primary" @click.stop="insert()">
                        Inserisci
                    </b-button>
                </div>
            </div>

            <!-- Main table element -->
            <b-table responsive v-show="showtable" id="main-table" striped hover show-empty :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered" empty-text="Non sono stati trovati record da visualizzare" empty-filtered-text="Non sono stati trovati record corrispondenti alla tua richiesta">
                <template slot="id" scope="row">{{row.value}}</template>
                    <template slot="domanda" scope="row">{{row.value}}</template>
                    <template slot="flagstaVis" scope="row">{{row.value}}</template>
                    <template slot="tipologia" scope="row">{{row.value}}</template>
                    <template slot="ordinamento" scope="row">{{row.value}}</template>

                    <template slot="modifica" scope="row">
                        <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
                        <b-btn style="margin:0px 0px 1px 2px;" variant="warning" size="sm" @click.stop="deldomanda(row.item,row.index,$event.target)">Elimina</b-btn>
                        <b-btn style="margin:0px 0px 1px 2px;" size="sm" @click.stop="details(row.item,row.index,$event.target)">Modifica</b-btn>
                    </template>

            </b-table>

            <div class="row my-1">
                <div class="col-md-8 col-sm-12">
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
                </div>
                <div class="col-md-4 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="pageOptions" v-model="perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>

        <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>

    </b-card>
    
    <!-- Modal Component -->
    <b-modal v-model="deleteModal.show" title="Elimina">
        <p class="my-2">Confermi l'eliminazione della domanda #{{deleteModal.id}}: {{deleteModal.domanda}}?</p>
        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="primary" @click="delItem()" style="margin: 2px;">
                Conferma
            </b-btn>
            <b-btn size="sm" class="float-right" variant="secondary" @click="deleteModal.show=false" style="margin: 2px;">
                Annulla
            </b-btn>
        </div>
    </b-modal>

</div>
</template>

<script>

import {
    NAMESPACE
} from '../config.js'

import {
    ctrlVismenu
} from '../util.js'

export default {
    name: 'apptable',
    data: function () {
        return {            
            items: [],
            namespace: NAMESPACE,
            fields: {
                id: {
                    label: '#',
                    sortable: true
                },
                domanda: {
                    label: 'Domanda',
                    sortable: true
                },
                flagstaVis: {
                    label: 'Attiva',
                    sortable: true
                },                
                tipologia: {
                    label: 'Tipo domanda',
                    sortable: true
                }, 
                ordinamento: {
                    label: 'Ordinamento',
                    sortable: true
                },              
                modifica: {
                    label: ' ',
                    'class': 'text-right'
                }
            },            
            id_questionariodomande: this.$route.params.id || null,
            deleteModal: {
                id: null,
                domanda: '',
                show: false
            },
            currentPage: 1,
            perPage: 10,
            pageOptions: [{
                text: 10,
                value: 10
            }, {
                text: 25,
                value: 25
            }, {
                text: 50,
                value: 50
            }],
            sortBy: null,
            sortDesc: false,
            filter: null,
            totalRowsFilter: null,            
            error: '',
            showerror: false,
            showtable: false
        };
    },
    computed: {
        totalRows: {
            // getter
            get: function () {
                return this.totalRowsFilter || this.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.totalRowsFilter = newValue;
            }
        }
    },
    methods: {
        insert() {
            this.$router.push('/app/dettagliodomanda/id_questionariodomande/' + this.id_questionariodomande);
        },
        details(item, index, button) {
            this.$router.push({
                path: `/app/dettagliodomanda/${item.id}`
            });
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        deldomanda(item, index, button) {
            this.deleteModal.id = item.id;
            this.deleteModal.domanda = item.domanda;
            this.deleteModal.show = true;
        },
        delItem() {

            var apptable = this;

            var token = localStorage.getItem('token');
            this.axios.delete(NAMESPACE + 'rest/domandedettaglio/' + this.deleteModal.id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            //forse può essere fatta diversamente e meglio
                            for (var i = 0; i < apptable.items.length; i++) {
                                if (this.items[i].id == this.deleteModal.id) {
                                    this.items.splice(i, 1); //delete
                                    break;
                                }
                            }
                            this.deleteModal.show = false;

                        } else {
                            throw new Error(response.data.message);
                        }

                    } catch (e) {

                        this.deleteModal.show = false;
                        apptable.showerror = true;
                        apptable.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {

                    this.deleteModal.show = false;
                    apptable.showerror = true;
                    apptable.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });
        
        }
    },
    created: function () {

        

        if(!ctrlVismenu("Q")){
            this.$router.replace('/accessdenied');
            return;
        }

        
        var id_questionariodomande = this.id_questionariodomande;
        //alert(id_questionariodomande);
        var token = localStorage.getItem('token');
        this.axios.get(NAMESPACE + 'rest/domandedettaglio/idquest/' + id_questionariodomande, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                try {

                    if (!response.data.error) {

                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                        this.items = response.data.message;
                        let apptable = this;

                        apptable.items.forEach(function(element, index) {
                            element.flagstaVis = (element.flagsta == 'S' ? 'Sì' : 'No');       
                            //element.tipodomandaVis = element.tipodomandaVis; 
                            //alert(element.domanda);                     
                        });

                        this.showtable = true;

                    } else {
                        throw new Error(response.data.message);
                    }

                } catch (e) {
                    this.showerror = true;
                    this.error = "Errore: " + e.message;
                }

            })
            .catch(e => {
                this.showerror = true;
                this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
            });

    }
}
</script>
